import React from "react";
import * as St from "./styles";

interface TabItemProps {
    label: string;
    flexGrow: number;
    isActive: boolean;
    disabled?: boolean;
    onClick: () => void
}

const TabItem: React.FC<TabItemProps> = ({
    label,
    flexGrow,
    isActive,
    disabled = false,
    onClick
}) => {
    return (
        <St.Tab
            flexGrow={flexGrow}
            isActive={isActive}
            disabled={disabled}
            onClick={onClick}
        >
            {label}
        </St.Tab>
    );
};

export default TabItem;
